import React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorRoute } from './routes/Error';
import { App } from './App';
import { apiEndpoints } from './lib/apiEndpoints/apiEndpoints';
import { getInitialMaintenanceState, MaintenanceGate } from './maintenance';

async function main() {
  await apiEndpoints.initialize();
  const container = document.getElementById('root');
  if (!container) {
    throw ErrorRoute('there is no #root element');
  }
  const root = createRoot(container);
  const maintenanceUrl = apiEndpoints.getAPIEndpoint('maintenance');
  const initialMaintenanceState = await getInitialMaintenanceState(maintenanceUrl);

  root.render(
    <React.StrictMode>
      <MaintenanceGate initialState={initialMaintenanceState} maintenanceUrl={maintenanceUrl}>
        <App />
      </MaintenanceGate>
    </React.StrictMode>,
  );
}
main().catch((error) => {
  console.error('Failed to initialize application:', error);
});
